export default function formatYearlyPrice(yearlyPrice: number): string {
    return `$${yearlyPrice/100}`
}
